export const WORKSPACE_URL = '/workspace';
